<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click.stop="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span /></td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Verze image' | translate">
        <a>{{ entity.image_version }}</a>
    </td>
    <td :data-th="'Verze splash' | translate">
      <a>{{ entity.splash_version }}</a>
    </td>
    <td :data-th="'Operátor' | translate">
      <a class="link" @click.stop="showOperatorDetail(entity.id_operator)">{{ entity.operator_name }}</a>
    </td>
    <td :data-th="'Zařízení' | translate">
      <a class="link" @click.stop="showDeviceDetail(entity.id_device)">{{ entity.device_name }}</a>
    </td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="!entity.id_device"
            class="btn btn_action btn_enable"
            :title="'Přiřadit k zařízení' | translate"
            @click.stop="addDeviceAssignment"
            v-translate>Přiřadit k zařízení
        </a>
        <a
            v-if="entity.id_device"
            class="btn btn_action btn_disable"
            :title="'Zrušit přiřazení k zařízení' | translate"
            @click.stop="removeDeviceAssignment"
            v-translate>Zrušit přiřazení k zařízení
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import links from "../../../mixins/links";

export default {
  name: 'DeviceDetailBootConfigRow',
  mixins: [rowActions, links],
  props: {
    device: Object,
    entity: Object,
  },
  created (DeviceBootConfigService) {
    this.configService = DeviceBootConfigService
  },
  data() {
    return {
      moduleName: 'devices',
    }
  },
    methods: {
    goToDetail(e, id) {
      this.$router.push({name: 'deviceBootConfigDetail', params: {id: id}})
    },
    addDeviceAssignment() {
      this.configService.updateEntity(this.entity.id, { id_device: this.device.id }).then(r => {
        this.$emit('reload')
      })
    },
    removeDeviceAssignment() {
      this.configService.updateEntity(this.entity.id, { id_device: null }).then(r => {
        this.$emit('reload')
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceBootConfigRow.vue